/* eslint-disable */
import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Row, Divider } from 'antd';
import { FormattedMessage } from 'react-intl';
import { mapLastTransactionsTableData } from 'Reports/utils';
import { DateRange } from 'Common/types';
import { ReportType } from 'utils/apiClient/services/reports/types';
import LastTransactionsTable from './views/LastTransactionsTable';
import { useIncomeTransactions } from '../hooks/dashboard';

const Title = styled.h3`
  margin: 0;
  line-height: 2em;
`;

type Props = {
  dateRange: DateRange;
  currency: string;
};
const LastTransactions: React.FC<Props> = ({ dateRange, currency }) => {
  const filterOptions = useMemo(
    () => ({ dateRange, type: ReportType.Daily, sort: '-date' }),
    [dateRange]
  );
  const lastTransactions = useIncomeTransactions(filterOptions);

  return (
    <>
      <Row css="padding: 1em 1.2em">
        <Title>
          <FormattedMessage defaultMessage="Last transactions" />
        </Title>
      </Row>
      <Divider css="margin: 0" />
      <div css="padding: 24px">
        <LastTransactionsTable
          loading={lastTransactions.isLoading}
          currency={currency}
          transactions={
            !!lastTransactions.data
              ? mapLastTransactionsTableData({
                  data: {
                    transactions: lastTransactions.data.slice(0, 10),
                  },
                })
              : []
          }
        />
      </div>
    </>
  );
};

export default LastTransactions;
